// AIDEV-NOTE: UTM attribution tracking for sign-up analytics
// These fields are captured from URL parameters when users first arrive at the app
export interface TAttribution {
    utm_campaign?: string;
    utm_content?: string;
    utm_source?: string;
    utm_medium?: string;
    utm_term?: string;
    referrer?: string; // document.referrer on first landing
    original_referrer?: string; // External referrer origin before the marketing site, forwarded as ?orig_ref=
    landing_page?: string; // First URL path they landed on
    captured_at?: string; // ISO timestamp when attribution was captured
    fbclid?: string; // Meta/Facebook click ID for CAPI attribution
    gclid?: string; // Google click ID for GA4/Ads attribution
    rdt_cid?: string; // Reddit click ID for Reddit Ads attribution
}

// Standard UTM parameter keys for extraction from URL
export const UTM_PARAMS = [
    "utm_campaign",
    "utm_content",
    "utm_source",
    "utm_medium",
    "utm_term",
] as const;

export type UTMParam = (typeof UTM_PARAMS)[number];

// AIDEV-NOTE: The Framer marketing site (partscompanion.org) records the visitor's first external
// referrer and appends it to app links as ?orig_ref=<origin>. Without it every marketing-site
// signup shows referrer=partscompanion.org, hiding google/chatgpt/facebook/etc. Origin-only.
export const ORIGINAL_REFERRER_PARAM = "orig_ref";
